import React from 'react';
import { Button } from 'components';
import { invitePartnerToKreditdata } from 'api/neway';
import { useSelector } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import getConfig from 'next/config';

const ComponentsPartnerKreditdataInviteButton = ({ children, onSuccess, flow, partnerEmail, ...rest }) => {
    const { publicRuntimeConfig:{ uniify } } = getConfig();
    const user = useSelector(state => state.user);
    const handleClick = async () => {
        const redirectUrl = `${window.location.origin}/partner-uniify-flow-complete?user_id=${user.userId}`;
        if(!user.userId){
            Alert('Der er noget galt, prøv igen senere');
        }
        const link = await invitePartnerToKreditdata({ redirectUrl, partnerEmail, flow });
        onSuccess({ link });
    };
    return (
        <Button
            { ...rest }
            style={{ minHeight: '42px', ...rest.style }}
            onClick={ async () => {
                await handleClick();
            } }
        >
            { children }
        </Button>
    );
};

ComponentsPartnerKreditdataInviteButton.defaultProps = {};

ComponentsPartnerKreditdataInviteButton.propTypes = {};

export default ComponentsPartnerKreditdataInviteButton;
